<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Modification du guichet <strong>{{atm.nom}}</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="device">Nom</label>
              <b-form-input type="text" v-model="atm.nom" placeholder="Nom du guichet"></b-form-input>
            </b-col>
            <!-- <b-col md="6">
              <label for="agence_id">Agence *</label>
                <el-select style="display:block;"
                  v-model="atm.agence_id" id="agence_id"
                  loading-text="Chargement en cours"
                  no-match-text="Agence non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  
                  reserve-keyword
                  placeholder="Rechercher le nom de votre agence"
                  :remote-method="remoteAgencies"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col> -->
            <b-col md="6">
              <label for="entite_id">Agences</label>
              <b-form-select id="agence_id" :plain="true" :options="options" v-model="atm.agence_id" disabled>
              </b-form-select>
            </b-col>

          </b-row>
          <div slot="footer">
            <span v-if="can('guichet-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger" ><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      atm:{
        agence_id: '',
        nom: '',
        _method: 'PUT'
      },
      agencies:[],
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 20
      },

      options4: [],
      value9: [],
      list: [],
      loading: false,
      states: []
    }
  },
  methods:{
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    goBack() {
      this.$router.go(-1)
    },
    async put(){     
        this.response =await this.$store.dispatch('atm/put_guichets',{id:this.$route.params.id,atm:this.atm})
        this.showAlert()
    },
    async displayATM(){
        let response = await this.$store.dispatch('atm/show_guichets',this.$route.params.id)
        this.atm.agence_id= response.agence_id,
        console.log("la response ",this.atm.agence_id)
        this.atm.nom= response.nom,
        this.atm.solde= response.solde
    },
    async get_all_agencies(){
          //this.agencies =  await store.getters['agency/rows'];
          await this.$store.dispatch('agency/get_all_agenciesOwn',this.serverParams).then(()=>{
            return this.agencies =  store.getters['agency/rows'];
          })
          this.agencies.forEach((element)=>{
              this.options.push({
                value:element.id,
                text:element.nom_agence,
              })
          })
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    remoteAgencies(query) {
        
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.options.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options4 = [];
        }
    }
  },
  async mounted(){
    await this.get_all_agencies()
    this.displayATM()
  }
}
</script>
